import { Container, Dialog, DialogContent, DialogTitle, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import _ from 'lodash';

import { makeStyles, withStyles } from 'tss-react/mui';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useRecoilValue } from 'recoil';
import { AxlButton } from '../../../components/AxlButton';
import { selectedDps } from '../../../atoms/DspState';
import ListHeader from '../../../components/ListHeader';

import { approveUserID, getListDSPUser, getUserType } from '../../../repositories/HttpRepository';

const fields = [
  {
    id: 'id',
    label: 'User ID',
    isDisableSort: true,
  },
  {
    id: 'username',
    label: 'Username',
    isDisableSort: true,
  },
  {
    id: 'email',
    label: 'Email',
    isDisableSort: true,
  },
  {
    id: 'phone_number',
    label: 'Phone Number',
    isDisableSort: true,
  },
  {
    id: 'type',
    label: 'Type',
    isDisableSort: true,
  },
  {
    id: 'status',
    label: 'Status',
    isDisableSort: true,
  },
  {
    id: 'action',
    label: 'Action',
    isDisableSort: true,
  },
];

const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
  },
  form: {
    display: 'flex',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
    border: '1px solid #e0e0eb',
  },
  table: {
    minWidth: 750,
  },
  dialogTitle: {
    paddingLeft: 0,
    '& h2': {
      fontWeight: 700,
    },
  },
  basicInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '10px',
  },
  closeBtn: {
    position: 'absolute',
    right: 40,
    top: 15,
    color: '#d8d8d8',
    fontSize: 44,
    cursor: 'pointer',
  },
}));

export const TableButton = withStyles(AxlButton, {
  root: {
    minWidth: 'unset',
    padding: '4px 6px',
    marginLeft: '5px',
    marginTop: '5px',
  },
});
const List = () => {
  const navigate = useNavigate();
  const { classes } = useStyles();
  const { courierId } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [isNeedReload, setIsNeedReload] = useState(false);
  const [userList, setUserList] = useState([]);
  const [userListType, setUserListType] = useState([]);
  const selectedDsp = useRecoilValue(selectedDps);

  useEffect(() => {
    getUserType().then((resp) => {
      if (resp.ok) {
        setUserListType(resp.data);
      }
    });
  }, []);

  useEffect(() => {
    getListDSPUser(courierId).then((resp) => {
      if (resp.ok) {
        setUserList(resp.data);
      }
    });
  }, [isNeedReload, courierId]);

  const approveAction = (e, userId) => {
    setIsLoading(true);
    if (userId) {
      approveUserID(userId)
        .then((rsp) => {
          if (rsp.ok) {
            toast.success('Approve successfully');
            setIsNeedReload(!isNeedReload);
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
      toast.error('User ID not found');
    }
  };

  function handleCancel() {
    window.setTimeout(() => {
      navigate('/dsp');
    }, 10);
  }
  return (
    <Dialog
      fullWidth
      maxWidth={false}
      open
      onClose={() => {
        navigate('/dsp');
      }}
    >
      <DialogContent>
        <Container maxWidth={false}>
          <DialogTitle id="form-dialog-title" className={classes.dialogTitle}>
            User's List
          </DialogTitle>
          <CloseIcon className={classes.closeBtn} onClick={handleCancel} />
          <div className={classes.basicInfo}>
            <div>
              <p>
                Company name: <strong>{selectedDsp.company}</strong>
              </p>
            </div>
          </div>
          <Paper elevation={0} className={classes.paper}>
            <TableContainer>
              <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table">
                <ListHeader fields={fields} />
                <TableBody>
                  {userList?.length === 0 && (
                    <TableRow>
                      <TableCell component="th" scope="row" colSpan={7} align="center">
                        No data found
                      </TableCell>
                    </TableRow>
                  )}
                  {userList.map((item, index) => {
                    if (!item) {
                      return;
                    }
                    const status = _.get(item, 'status', '-');
                    const labelId = `user-table-item-${index}`;
                    const typeKey = _.get(item, 'type', '-');
                    // const type = userListType.find(e => e.code === typeKey)?.name
                    return (
                      <TableRow hover tabIndex={-1} key={`user-${item.id}`}>
                        <TableCell component="th" id={labelId} scope="row">
                          {_.get(item, 'user.id', '-')}
                        </TableCell>
                        <TableCell>{_.get(item, 'user.username', '-')}</TableCell>
                        <TableCell>{_.get(item, 'user.email', '-')}</TableCell>
                        <TableCell>{_.get(item, 'user.phone', '-')}</TableCell>
                        <TableCell>{typeKey}</TableCell>
                        <TableCell>{status}</TableCell>
                        <TableCell>
                          {status === 'PENDING' && (
                            <TableButton variant="contained" className="bgPrimary" onClick={(e) => approveAction(e, _.get(item, 'user.id', undefined))}>
                              {' '}
                              Approve
                            </TableButton>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
              {isLoading && <LinearProgress />}
            </TableContainer>
          </Paper>
        </Container>
      </DialogContent>
    </Dialog>
  );
};
export default React.memo(List);
